<template>
  <component :is="layout">
    <keep-alive exclude="card">
      <router-view />
    </keep-alive>
  </component>
</template>

<script>
import { AUTH_REFRESH } from "@/store/types";
import { mapGetters } from "vuex";

export default {
  computed: {
    layout() {
      return `${this.$route.meta.layout || "default"}-layout`;
    }
  },
  async created() {
    try {
      await this.$store.dispatch(AUTH_REFRESH);
      if (this.$route.name === "login") {
        this.$router.push({ name: "analytics" });
      }
    } catch (err) {
      if (this.$route.meta.public === false) {
        this.$router.push({ name: "login" });
      }
    }
  }
};
</script>
<style>
</style>
